import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { selectIsAuthenticated } from '../../state/auth/auth.selectors';

/** Blocks the app shell until the store staff has signed in. */
export const authGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  return store.selectSignal(selectIsAuthenticated)() ? true : router.createUrlTree(['/login']);
};

/** Keeps an already-authenticated user off the login screen. */
export const guestGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  return store.selectSignal(selectIsAuthenticated)() ? router.createUrlTree(['/catalog']) : true;
};
